import {ALL_FORMATS,BlobSource,CanvasSink,Input,UrlSource} from 'mediabunny';
export type DecodedMaskFrame={canvas:HTMLCanvasElement|OffscreenCanvas|null;timestamp:number;width:number;height:number;hasAudio:boolean};
export type MaskVideoReader={read:(time:number,minimum:number,current:()=>boolean)=>Promise<DecodedMaskFrame>;dispose:()=>void};
/** Decoder timestamps, not requested timeline times, own moving mask positions. */
export function createMaskVideoReader(src:string,createUrlSource:(url:string)=>UrlSource=url=>new UrlSource(url,{requestInit:{cache:'reload',credentials:'omit'},getRetryDelay:()=>null,maxCacheSize:32*1024*1024})):MaskVideoReader{
  const source=src.startsWith('data:')?new BlobSource(new Blob([Uint8Array.from(atob(src.slice(src.indexOf(',')+1)),char=>char.charCodeAt(0))],{type:src.slice(5,src.indexOf(';'))})):createUrlSource(src);
  const input=new Input({formats:ALL_FORMATS,source});
  let closed=false;let queue:Promise<unknown>=Promise.resolve();
  let last:DecodedMaskFrame&{requestTime:number}|null=null;
  const ready=(async()=>{
    const track=await input.getPrimaryVideoTrack();
    if(!track||!await track.canDecode())throw new Error('이 환경에서는 모자이크 원본 프레임을 디코딩할 수 없습니다. 지원되는 원본을 선택하거나 모자이크 설정을 수정해 주세요.');
    const hasAudio=!!await input.getPrimaryAudioTrack();
    return {sink:new CanvasSink(track,{alpha:true}),hasAudio};
  })();
  ready.catch(()=>{});
  return {
    read(time,minimum,current){
      const task=queue.then(async()=>{
        if(!Number.isFinite(time)||!Number.isFinite(minimum))throw new Error('원본 프레임 요청 시각이 올바르지 않습니다.');
        if(closed||!current())throw new Error('이전 프레임 요청을 취소했습니다.');
        const {sink,hasAudio}=await ready;
        if(closed||!current())throw new Error('이전 프레임 요청을 취소했습니다.');
        if(last&&last.timestamp>=minimum&&time===last.requestTime)return last;
        const frame=time<0?null:await sink.getCanvas(time);
        if(!frame||frame.timestamp<minimum)return {canvas:null,timestamp:time,width:1,height:1,hasAudio};
        last={canvas:frame.canvas,timestamp:frame.timestamp,width:frame.canvas.width,height:frame.canvas.height,hasAudio,requestTime:time};return last;
      });
      queue=task.catch(()=>{});return task;
    },
    dispose(){closed=true;last=null;input.dispose();},
  };
}
export async function publishMaskedFrame(reader:MaskVideoReader,time:number,minimum:number,current:()=>boolean,publish:(frame:DecodedMaskFrame)=>void){
  try{
    const frame=await reader.read(time,minimum,current);
    if(!current())return false;
    if(!Number.isFinite(frame.timestamp)||frame.timestamp>time+1e-7||(frame.canvas!==null&&frame.timestamp<minimum)||!Number.isFinite(frame.width)||!Number.isFinite(frame.height)||frame.width<=0||frame.height<=0)throw new Error('원본 프레임 시각을 확인하지 못했습니다.');
    publish(frame);return true;
  }catch(error){if(!current())return false;throw error;}
}
